import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import { formatString } from '../../utils/StringUtils';
import { formatCurrency } from '../../utils/formatMoeda';
import useDefaultModal from '../hooks/useDefaultModal';
import useConfirmModal from '../hooks/useConfirmModal';
import DefaultModal from './DefaultModal';
import ConfirmModal from './ConfirmModal';
import usePagination10 from '../hooks/usePagination10';
import LoteModal from '../modalServices/LoteModal';
import useProgressModal from '../hooks/useProgressModal';
import ExcelUploadLoteModal from '../modalServices/ExcelUploadLoteModal';
import DemandaLoteItensModal from './DemandaLoteItensModal';
import TableContainer from '../TableContainer';
import DataTable from '../DataTable';
import PaginationBar from '../PaginationBar';

function DemandaLotesModal({ show, onClose, demanda }) {
  const [showLoteModal, setShowLoteModal] = useState(false);
  const [loteParaEditar, setLoteParaEditar] = useState(null);
  const [showExcelUploadModal, setShowExcelUploadModal] = useState(false);
  const [showDemandaLoteItensModal, setShowDemandaLoteItensModal] = useState(false);

  async function handleSaveLote(payload) {
    setLoading(true);
    try {
      let response;
      if (payload.modo === 'editar' && payload.id) {
        response = await axios.post(
          `${API_BASE_URL.DEMANDA_LOTE}/save`,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const loteEditado = response.data;
        setDemandas(prev =>
          prev.map(l => (l.id === loteEditado.id ? loteEditado : l))
        );
        showDefaultModal('success', 'Lote editado com sucesso!');
      } else {
        response = await axios.post(
          `${API_BASE_URL.DEMANDA_LOTE}/save`,
          payload,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const novoLote = response.data;
        setDemandas(prev => [...prev, novoLote]);
        setSelectedDemanda(novoLote);
        showDefaultModal('success', 'Lote cadastrado com sucesso!');
      }
    } catch (error) {
      showDefaultModal(
        'error',
        payload.modo === 'editar'
          ? 'Erro ao editar lote.'
          : 'Erro ao cadastrar lote.'
      );
    } finally {
      setLoading(false);
      setLoteParaEditar(null);
      setShowLoteModal(false);
    }
  }
  const [demandas, setDemandas] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [shouldFetch, setShouldFetch] = useState(false);
  const [selectedDemanda, setSelectedDemanda] = useState(null);
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const anoBase = localStorage.getItem('anoBase');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const {
    progressState,
    showProgressModal,
    updateProgress,
    hideProgressModal,
  } = useProgressModal();
  const totalItems = demandas.length;
  const { setPagination } = usePagination10(totalItems);

  const selectedDemandas =
    demandas && setPagination
      ? demandas.slice(
          setPagination.startIndex,
          setPagination.startIndex + setPagination.rowsPerPage
        )
      : [];

  useEffect(() => {
    if (
      selectedDemanda &&
      !selectedDemandas.find(demanda => demanda.id === selectedDemanda.id)
    ) {
      setSelectedDemanda(null);
    }
  }, [selectedDemandas, selectedDemanda]);

  useEffect(() => {
    if (!show) {
      setSelectedDemanda(null);
      setDemandas([]);
      return;
    }
    setLoading(true);
    axios
      .get(`${API_BASE_URL.DEMANDA_LOTE}/all`, {
        params: {
          cnpj: cnpj,
          demandaNum: demanda?.num,
        },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        setDemandas(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter lotes:', error);
      });
    setLoading(false);
  }, [demanda, cnpj, token, shouldFetch, show]);

  if (!demandas) {
    return null;
  }

  function handleDelete(demandaToDelete) {
    showConfirmModal('delete', () => handleDeleteConfirm(demandaToDelete));
  }

  function handleDeleteConfirm(demandaToDelete) {
    console.log('DADOS PARA DELETAR: ', demandaToDelete);
    if (demandaToDelete) {
      axios
        .get(`${API_BASE_URL.DEMANDA_ITEM}/exists_lote`, {
          params: {
            cnpj: demandaToDelete.cnpj,
            demandaNum: demandaToDelete.demandaNum,
            loteNum: demandaToDelete.id,
          },
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(result => {
          if (result.data.exists) {
            showDefaultModal(
              'error',
              'Este registro possui vínculos e não pode ser excluído. Exclua os vínculos e tente novamente.'
            );
          } else {
            axios
              .delete(`${API_BASE_URL.DEMANDA_LOTE}/delete`, {
                params: {
                  cnpj: demandaToDelete.cnpj,
                  demandaNum: demandaToDelete.demandaNum,
                  loteNum: demandaToDelete.id,
                },
                headers: { Authorization: `Bearer ${token}` },
              })
              .then(result => {
                setDemandas(prevState =>
                  prevState.filter(item => item.num !== demandaToDelete.num)
                );
                showDefaultModal(
                  'success',
                  'O registro foi excluído com sucesso'
                );
              })
              .catch(error => {
                console.error('Erro ao excluir o item:', error);
                showDefaultModal('error', 'Erro ao excluir o registro!');
              });
          }
        });
    }
  }

  async function handleExportToExcel() {
    try {
      const response = await axios.post(
        `${API_BASE_URL.DEMANDA}/exportExcelLote`,
        demanda,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
          responseType: 'blob',
        }
      );

      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `DEMANDA ${formatString(
        demanda?.demandaNum,
        3
      )} LOTES.xlsx`;
      link.click();
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
    }
  }

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: '96vw', height: '90vh' }}
        >
          <div className="modal-content" style={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div
              className="modal-header text-white"
              style={{
                background:
                  'linear-gradient(45deg, rgb(19, 72, 156) 0%, rgba(19, 72, 156, 1) 100%)',
                padding: '0.35rem 0.75rem',
                border: 'none',
                flexShrink: 0,
              }}
            >
              <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
                <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
                  <i className="bi bi-boxes me-2"></i>
                  Lotes da Demanda Nº {demanda ? formatString(demanda.num, 4) : '--'}
                </h6>
                <div className="d-flex align-items-center gap-2">
                  <button
                    className="btn btn-link text-white p-0 mb-0"
                    onClick={onClose}
                    title="Fechar"
                    style={{ fontSize: '1rem', textDecoration: 'none' }}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="modal-body" style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: '0.75rem' }}>
              <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2" style={{ flexShrink: 0 }}>
                <div className="d-flex gap-2 flex-wrap">
                  <button
                    className="btn btn-success btn-sm d-inline-flex align-items-center"
                    title="Novo Lote"
                    onClick={() => {
                      setLoteParaEditar(null);
                      setShowLoteModal(true);
                    }}
                  >
                    <i className="bi bi-plus-circle me-1"></i>Novo
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    disabled={!selectedDemanda}
                    onClick={() => {
                      if (!selectedDemanda) return;
                      setLoteParaEditar(selectedDemanda);
                      setShowLoteModal(true);
                    }}
                    title="Editar lote selecionado"
                  >
                    <i className="bi bi-pencil-square me-1"></i>Editar
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    disabled={!selectedDemanda}
                    onClick={() => {
                      if (!selectedDemanda) return;
                      handleDelete(selectedDemanda);
                    }}
                    title="Excluir lote"
                  >
                    <i className="bi bi-trash3 me-1"></i>Excluir
                  </button>
                </div>
                <div className="d-flex gap-2 flex-wrap align-items-center">
                  <button
                    className="btn btn-info btn-sm"
                    disabled={!selectedDemanda}
                    onClick={() => {
                      if (!selectedDemanda) return;
                      setShowDemandaLoteItensModal(true);
                    }}
                    title="Ver itens do lote"
                  >
                    <i className="bi bi-list-ul me-1"></i>Itens
                  </button>
                  <button
                    onClick={handleExportToExcel}
                    className="btn btn-info btn-sm d-inline-flex align-items-center"
                    title="Exportar Planilha Excel"
                    disabled={progressState.show}
                  >
                    <i className="bi bi-file-earmark-excel me-1" />
                    Exportar Excel
                  </button>
                  <button
                    className="btn btn-warning btn-sm d-inline-flex align-items-center"
                    title="Importar Planilha Excel"
                    onClick={() => setShowExcelUploadModal(true)}
                    disabled={progressState.show}
                  >
                    <i className="bi bi-file-earmark-arrow-down me-1" />
                    Importar Excel
                  </button>
                </div>
              </div>
              <TableContainer isLoading={isLoading}>
                <DataTable style={{ fontSize: '0.8rem' }} head={
                    <tr>
                      <th
                        scope="col"
                        className="align-middle text-center"
                        style={{ width: '5%' }}
                      >
                        Nº
                      </th>
                      <th scope="col" className="align-middle">
                        Descrição
                      </th>
                      <th
                        scope="col"
                        className="align-middle text-center"
                        style={{ width: '10%' }}
                      >
                        Qtd. Itens
                      </th>
                      <th
                        scope="col"
                        className="align-middle text-end"
                        style={{ width: '15%' }}
                      >
                        Valor Estimado
                      </th>
                    </tr>
                  }>
                  <tbody>
                    {!isLoading && selectedDemandas.length > 0 ? (
                      selectedDemandas.map(c => {
                        const isActiveRow =
                          selectedDemanda && selectedDemanda.id === c.id;
                        return (
                          <tr
                            key={`${c.cnpj}-${c.demandaNum}-${c.id}`}
                            className={isActiveRow ? 'table-primary fw-bold' : ''}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setSelectedDemanda(
                              selectedDemanda && selectedDemanda.id === c.id ? null : c
                            )}
                            title={
                              isActiveRow
                                ? 'Lote selecionado'
                                : 'Clique para selecionar'
                            }
                          >
                            <td className="text-center" style={{ width: '5%' }}>{c.id}</td>
                            <td>{c.descricao}</td>
                            <td className="text-center" style={{ width: '10%' }}>{c.qtdItens ?? 0}</td>
                            <td className="text-end" style={{ width: '15%' }}>{formatCurrency(c.valorEstimado || 0)}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          Nenhum registro encontrado.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </DataTable>
              </TableContainer>
            </div>
            <PaginationBar setPagination={setPagination}/>
          </div>
        </div>
      </div>
      <LoteModal
        isOpen={showLoteModal}
        demanda={demanda}
        lote={loteParaEditar}
        onClose={() => {
          setShowLoteModal(false);
          setLoteParaEditar(null);
        }}
        onSuccess={handleSaveLote}
      />
      <ExcelUploadLoteModal
        show={showExcelUploadModal}
        onClose={() => {
          setShowExcelUploadModal(false);
          setShouldFetch(prev => !prev);
        }}
        onSuccess={() => setShouldFetch(prev => !prev)}
        demanda={demanda}
      />
      <DemandaLoteItensModal
        show={showDemandaLoteItensModal}
        onClose={() => {
          setShowDemandaLoteItensModal(false);
          setShouldFetch(prev => !prev);
        }}
        demanda={demanda}
        demandaLote={selectedDemanda}
      />
      <ConfirmModal {...setConfirmModal} />
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default DemandaLotesModal;
